/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_TitleInputs */

const vi_vehicle_title = /** @type {(inputs: Vehicle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương tiện`)
};

/**

* @param {Vehicle_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_title = /** @type {((inputs?: Vehicle_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_title(inputs)
});